import React from 'react';
import classNames from 'classnames/bind';
import styles from './Counter.module.scss';

const cx = classNames.bind(styles);
function Counter(props) {
  const minCount = props.minCount ? props.minCount : 1;
  const maxCount = props.maxCount;
  const [currentCount, setCurrentCount] = React.useState(
    props.currentValue ? props.currentValue : minCount,
  );

  function changeCount(variation) {
    if (variation > 0) {
      if (currentCount < maxCount) {
        setCurrentCount(currentCount + 1);
        props.currentCount(currentCount + 1);
      } else {
      }
    } else {
      if (currentCount > minCount) {
        setCurrentCount(currentCount - 1);
        props.currentCount(currentCount - 1);
      } else {
      }
    }
  }
  return (
    <div
      className={cx(
        'counter',
        props.homeofficeDetail ? 'color-f97f54' : '',
        props.formatLetter ? '' : 'current-only-number',
      )}
    >
      <button
        className={cx('minus', currentCount <= minCount ? 'disable-minus' : '')}
        onClick={() => changeCount(-1)}
      />
      <div
        className={cx(
          'current',
          currentCount >= maxCount && currentCount <= minCount ? 'current-disable' : '',
        )}
      >
        {currentCount}
        {props.formatLetter}
      </div>
      <button
        className={cx('plus', currentCount >= maxCount ? 'disable-plus' : '')}
        onClick={() => changeCount(1)}
      />
    </div>
  );
}

export default Counter;
